<template>

    <div id="supplier_rayos_x">
        <!--FORM PAPELERIA-->
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">

            <upload-subsidiary
                v-show="modalSubsidiary"
                v-if="modalSubsidiary"
                :supplier_id="rowID"
                :role_id="12"/>

            <modal-stationery
                v-show="modalStationery"
                v-if="modalStationery"
                :supplier_id="rowID"
                :role_id="role_id"
                :folder_id="12"/>

            <modal-notes
                v-show="modalNotes"
                v-if="modalNotes"
                :user_id="user_id"
                :role_id="12"
                :supplier_id="rowID"/>

            <modal-services-supplier
                v-if="modalServices"
                :role_id="12"
                :supplier_id="rowID"/>

            <form v-show="modalForm" id="formRayosX" class="animated fadeIn formRayosX">
                <div v-if="modificar">
                    <input type="hidden" name="currentName" v-model="supplier.currentName">
                    <input type="hidden" name="currentEmail" v-model="supplier.currentEmail">
                    <input type="hidden" name="currentUserName" v-model="supplier.currentUserName">
                    <input type="hidden" name="currentLogo" v-model="supplier.currentLogo">
                </div>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <div id="fotoUsuarioAdmin">
                            <img v-if="supplier.logo" :src="'../storage/opticas/'+supplier.logo" alt="">
                            <img v-else :src="'../images/foto-usuario.jpg'" class="rounded-circle" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="fotoUploader">
                            <span class="btn btn-file">
                                Logotipo <br> <i class="fas fa-upload"></i> <input type="file" data-label="avatar"
                                                                                   name="logo" v-on:change="getLogo"
                                                                                   placeholder="avatar">
                            </span>
                            <span class="label-file-papeleria alert alert-info avatar"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <p class="fotoUploader">
                            Imagen o Logotipo, las imágenes serán escaladas a un tamaño de 300 &times; 300 px, en
                            formato y peso permitido de carga es: <br> <strong>.jpeg, .png, .jpg, .gif, .svg, con un
                            peso maximo de 3mb</strong>
                        </p>
                        <cite>
                            El correo asignado en este formulario se usara para iniciar sesión en el sistema.
                        </cite>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <cite>*Campos requeridos con linea roja.</cite>
                        <h2 class="cabeza">Datos Generales</h2>
                    </div>
                    <div class="col-12 col-md-3">
                        <p>
                            <input id="proveedor" v-model="supplier.proveedor" name="proveedor" type="text"
                                   class="al-inputs scr-input" placeholder="Nombre del Proveedor de Servicios*"/>
                            <label for="proveedor" class="scr-supertext">Nombre del Proveedor de Servicios*</label>
                        </p>
                    </div>

                    <div class="col-12 col-md-3">
                        <select id="estado" v-model="supplier.estado" v-on:change="selectCities($event)" name="estado"
                                data-select="on" class="required">
                            <option :value="0">Seleccione un Estado*</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">
                                {{ state.estado }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <select data-select="on" v-model="supplier.ciudad" name="ciudad" id="ciudad" class="required">
                            <option :value="0">Selecciona un Ciudad*</option>
                            <option v-for="city in cities" :value="city.cities_id" :key="city.cities_id">
                                {{ city.ciudad }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="tel_emp" v-model="supplier.tel_emp" name="tel_emp" type="tel"
                               class="al-inputs required scr-input" placeholder="Teléfono*"/>
                        <label for="tel_emp" class="scr-supertext">Teléfono*</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="dir_com" v-model="supplier.dir_com" name="dir_com" type="text"
                               class="al-inputs required scr-input" placeholder="Dirección Comercial"/>
                        <label for="dir_com" class="scr-supertext">Dirección Comercial</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="email" v-model="supplier.correo" name="correo" maxlength="10" type="email"
                               class="al-inputs required scr-input" placeholder="e-Mail*"/>
                        <label for="email" class="scr-supertext">e-Mail*</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="fecha" v-model="supplier.f_i_c" name="f_i_c" maxlength="10" type="date"
                               class="al-inputs scr-input" placeholder="Fecha Inicio Contrato*"/>
                        <label for="fecha" class="scr-supertext">Fecha Inicio Contrato*</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <h2 class="cabeza">Contacto Administrativo</h2>
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <input id="rep_legal" v-model="supplier.rep_legal" name="rep_legal" type="text"
                                       class="al-inputs required scr-input" placeholder="Nombre*"/>
                                <label for="rep_legal" class="scr-supertext">Nombre*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_email" v-model="supplier.rep_email" name="rep_email" type="text"
                                       class="al-inputs required scr-input" placeholder="E-mail*"/>
                                <label for="rep_email" class="scr-supertext">E-mail*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_tel" v-model="supplier.rep_tel" name="rep_tel" type="text"
                                       class="al-inputs required scr-input" placeholder="Teléfono*"/>
                                <label for="rep_tel" class="scr-supertext">Teléfono*</label>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <h2 class="cabeza">Contacto Operativo</h2>
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_nombre" v-model="supplier.rep_sec_nombre" name="rep_sec_nombre"
                                       type="text" class="al-inputs scr-input" placeholder="Nombre*"/>
                                <label for="rep_sec_nombre" class="scr-supertext">Nombre*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_email" v-model="supplier.rep_sec_email" name="rep_sec_email"
                                       type="text" class="al-inputs scr-input" placeholder="E-mail*"/>
                                <label for="rep_sec_email" class="scr-supertext">E-mail*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_tel" v-model="supplier.rep_sec_tel" name="rep_sec_tel" type="text"
                                       class="al-inputs scr-input" placeholder="Teléfono*"/>
                                <label for="rep_sec_tel" class="scr-supertext">Teléfono*</label>
                            </div>
                        </div>
                    </div>
                </div>

                <h2 class="cabeza">Datos de Autenticación</h2>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <input id="pass" v-model="supplier.username" name="username" type="text"
                               class="al-inputs scr-input" placeholder="Usuario"/>
                        <label for="pass" class="scr-supertext">Usuario</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="password" v-model="supplier.password" type="password" name="password"
                               class="al-inputs scr-input" :class="{required:!modificar}" placeholder="Password"
                               value=""/>
                        <label for="password" class="scr-supertext">Password</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Guardar
                        </button>
                    </div>
                </div>
            </form>

        </b-modal>

        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <!-- A virtual column -->
                            <template #cell(Proveedor)="data">
                                {{ data.item.proveedor }}
                            </template>
                            <template #cell(E-mail)="{item}">
                        <span v-if="item.reluser">
                            {{ item.reluser.email }}
                        </span>
                            </template>
                            <template #cell(Estado)="{item}">
                                {{ item.reledo.estado }}
                            </template>
                            <template #cell(Ciudad)="{item}">
                                {{ item.relcity.ciudad }}
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="rowID=item.id; openModalsProviders('stationery')">Subir
                                            Papelería</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="rowID=item.id; openModalsProviders('subsidiary')">Agregar
                                            Sucursales</a>
                                        <a class="dropdown-item" v-if="role_id===1" href="javascript:void(0)"
                                           v-on:click="rowID=item.id; openModalsProviders('note')">Agregar Nota</a>
                                        <a class="dropdown-item" v-if="role_id===1" href="javascript:void(0)"
                                           v-on:click="rowID=item.id; openModalsProviders('services')">Agregar
                                            Servicio</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {estadoService} from "../../Services/States.service";
import {statescitiesService} from "../../Services/Statescities.service";
import {supplierradiologyService} from "../../Services/SupplierRadiologia.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "supplier_rayos_x",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            filter: null,
            supplier: {
                id: 0,
                proveedor: '',
                correo: '',
                estado: 0,
                ciudad: 0,
                tel_emp: '',
                dir_com: '',
                rep_legal: '',
                rep_email: '',
                rep_tel: '',
                rep_sec_nombre: '',
                rep_sec_email: '',
                rep_sec_tel: '',
                status: 0,
                f_i_c: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentLogo: '',
            },
            params: {
                limit: 10,
                page: 1,
            },
            fields: [
                {
                    key: 'Proveedor',
                    sortable: false
                },
                {
                    key: 'E-mail',
                    sortable: false
                },
                {
                    key: 'Estado',
                    sortable: false
                },
                {
                    key: 'Ciudad',
                    sortable: false
                },
                {
                    key: 'Acciones',
                    sortable: false
                }
            ],
            states: [],
            cities: [],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            tituloBtn: 'Agregar',
            rowID: 0,
            titleItem: '',
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await supplierradiologyService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formRayosX');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formRayosX');
                if (this.modificar) {
                    resp = await supplierradiologyService.updateOne(this.supplier.id, formData, {
                        isForm: true,
                        onUploadProgress: this.onUploadProgress
                    });
                } else {
                    resp = await supplierradiologyService.saveOne(formData, {
                        isForm: true,
                        onUploadProgress: this.onUploadProgress
                    });
                }
                this.modificar = false;
                this.showModal = false;
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
                this.disableSubmitBtn(false);
            }
        },
        async index() {
            this.isBusy = true;
            this.pagination = await supplierradiologyService.getMany(this.params);
            this.states = await estadoService.getMany({limit: 0});
            this.isBusy = false;
        },
        async selectCities($e) {
            this.cities = await statescitiesService.getCitiesByState($e.target.value);
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.selectCities(data.estado);
                this.tituloBtn = 'Actualizar';
                this.supplier = data;
                this.supplier.ciudad = data.relcity.id;
                this.supplier.currentName = data.proveedor;
                this.supplier.currentEmail = data.correo;
                this.supplier.currentUserName = data.username;
                this.supplier.username = data.reluser.username;
                this.supplier.logo = data.logo;
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
        setEmpty() {
            this.supplier = {
                id: 0,
                proveedor: '',
                correo: '',
                estado: 0,
                ciudad: 0,
                tel_emp: '',
                dir_com: '',
                rep_legal: '',
                rep_email: '',
                rep_tel: '',
                rep_sec_nombre: '',
                rep_sec_email: '',
                rep_sec_tel: '',
                status: 0,
                f_i_c: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentLogo: '',
            }
        },
    },
    mounted() {
        this.index();
    }
}
</script>
